import { inject } from '@angular/core';

import { AuthService } from '../auth.service';

export const AuthGuard = () => {
	const { isAuthenticated, login } = inject(AuthService);
	if (!isAuthenticated) login();
	return isAuthenticated;
};
